// @ts-nocheck

import {
  Vue, Options
} from 'vue-class-component'
import swal from 'sweetalert'
import * as bootstrap from 'bootstrap'
import Header from '@/components/Header.vue'
import { orderFactory } from '@/http/order'
import { userFactory } from '@/http/user'
import { masterDataFactory } from '@/http/master-data'
import { billFactory } from '@/http/bill'
import { customerFactory } from '@/http/customer'
import Utils from '@/utils/utils'
import Datepicker from 'vue3-datepicker'
import constants from '@/constants/constants'
import VPagination from '@hennge/vue3-pagination'
import { setupFactory } from '@/http/setup'
import '@hennge/vue3-pagination/dist/vue3-pagination.css'
import { ref } from 'vue'
import roleAccessManager from '@/utils/role-access-manager'

@Options({
  components: {
    Header,
    Datepicker,
    VPagination
  },
  data() {
    return {
      selectAll: false,
      selected: [],
      showMassDeleteButton: false,
      orders: [],
      order: [],
      student: [],
      billUserInstallments: [],
      orderStatuses: {
        0: 'Semua Status',
        310: 'Aktif',
        320: 'Belum Bayar',
        330: 'Terbayar',
        331: 'Manual',
        340: 'Dibatalkan',
        341: 'Kedaluwarsa',
        350: 'Refunded',
        351: 'Refund Sebagian'
      },
      classes: [],
      merchants: [],
      param: {
        status: 0,
        date_from: null,
        date_to: null,
        keyword: '',
        offset: 0,
        limit: 20,
        order_by: 'desc',
        order_at: 'created_at',
        child_user_id: '',
        class_id: '',
        payment_date: null,
        total_payment: null,
        reff_no: null,
        merchant_type: ''
      },
      schoolYears: [],
      months: [],
      data_master: {
        school_years: '1',
        months: '1',
        classes: '1',
        merchants: '1'
      },
      totalPaid: 0,
      totalBill: 0,
      detailReady: false,
      loadingSave: false,
      paymentReady: false,
      currentPage: 1,
      totalPage: 1,
      searchField: '',
      modal: false,
      students: [],
      constants: constants,
      file: '',
      paymentFile: '',
      import_result: {
        rejected_orders: [],
        saved_orders: []
      },
      instance: '',
      manualPaymentByVA: false,
      billOption: [],
      spp_bill_id2: '',
      customInvoice: false,
      reference: {
        reff_no: '',
        invoice_no: '',
        total_payment: 0,
        payment_date: '',
        file_path: ''
      },
      referenceModal: null,
      disableFileUpload: false,
      refundModal: null,
      enableRefund: false,
      refundForm: {
        date: new Date(),
        amount: 0,
        method: 'transfer',
        notes: '',
        max_refundable: 0
      },
      refundHistory: [],
      refundFile: '',
      isUploadReferenceOptional: false,
      canCreate: false,
      canRead: false,
      canUpdate: false,
      canDelete: false
    }
  },
  watch: {
    '$route.query': {
      handler: 'onPageQueryChange',
      deep: true
    },
    selected: {
      handler: function (val: any) {
        this.selectAll = val.length === this.orders.filter((order: any) => order.status == constants.ORDER_EXPIRED).length
        this.showMassDeleteButton = val.length > 0
      },
      deep: true
    },
    searchField: function (val) {
      if (val.length == 0) {
        this.param.child_user_id = ''
      }
    }
  },
  methods: {
    setRouter: function () {
      this.$router.push({
        path: '/payment',
        query: {
          child_user_id: this.param.child_user_id,
          page: this.currentPage
        }
      })
    },
    onPageChanged(page: any) {
      if (page) {
        this.currentPage = page
      }
      page = Math.round(this.currentPage)
      if (this.totalPage >= page) {
        this.$router.push({ query: { page } })
      }
    },
    onPageQueryChange() {
      this.param.offset = (this.currentPage - 1) * parseInt(this.param.limit)
      this.loadData()
    },
    async getSuggestions() {
      if (this.searchField.length > 3) {
        const param = {
          keyword: this.searchField
        }
        Promise.resolve(userFactory.students(param))
          .then(result => {
            this.students = result.data.users[0]
            this.students.forEach((value: any) => {
              if (value.child_name != null) {
                value.name = value.child_name
                value.user_id = value.child_user_id
              }
            })
          }).catch((e) => {
            swal('Gagal melakukan request', '', 'error')
            console.log(e)
            this.students = []
          })
      } else {
        this.students = []
      }
    },
    setSearch(search: any) {
      this.searchField = search.name
      this.param.child_user_id = search.user_id
      this.modal = false
      this.setRouter()
    },
    getMonth: function (date: any) {
      if (date != '' && date != undefined) {
        const d = date.split('-')
        const month = d[2]
        return this.months[month].id
      } else {
        return ''
      }
    },
    beautifyDatetime: function (date: any) {
      return Utils.beautifyDatetime(date)
    },
    toLocaleString: function (val: any) {
      return Utils.toLocaleString(val)
    },
    formatDate: function (date: any) {
      const d = new Date(date)
      let month = '' + (d.getMonth() + 1)
      let day = '' + d.getDate()
      const year = d.getFullYear()
      if (month.length < 2) { month = '0' + month }
      if (day.length < 2) { day = '0' + day }
      return [year, month, day].join('-')
    },
    orderDetail: function (order_id: any) {
      this.detailReady = false
      Promise.all([
        orderFactory.detailOrder(order_id)
      ]).then(results => {
        this.order = results[0].data.order
        this.student = results[0].data.student
        this.billUserInstallments = results[0].data.bill_user_installments
        this.detailReady = true
        this.showModal()
      }).catch((e) => {
        swal('Gagal melakukan request', '', 'error')
        console.log(e)
      })
    },
    exportOrder: function () {
      const param = {
        status: this.param.status,
        date_from: null,
        date_to: null,
        keyword: this.param.keyword,
        order_by: 'desc',
        order_at: 'created_at',
        child_user_id: this.param.child_user_id,
        merchant_type: this.param.merchant_type
      }
      if (this.param.date_from) {
        param.date_from = this.formatDate(this.param.date_from)
      }
      if (this.param.date_to) {
        param.date_to = this.formatDate(this.param.date_to)
      }
      Promise.resolve(orderFactory.exportOrder(param))
        .then(() => {

        }).catch((e) => {
          swal('Gagal melakukan request', '', 'error')
          console.log(e)
        })
    },
    templateImport: function () {
      const param = {}
      Promise.resolve(orderFactory.templateImport(param))
        .then(() => {

        }).catch((e) => {
          swal('Gagal melakukan request', '', 'error')
          console.log(e)
        })
    },
    handleFileUpload: function () {
      this.file = this.$refs.file.files[0]
    },
    handlePaymentUpload: function (file) {
      this.paymentFile = file.files[0]
    },
    showImportModal: function () {
      this.import_result.rejected_orders = []
      this.import_result.saved_orders = []
      this.importModal.show()
    },
    importOrder: function () {
      if (this.file == '') {
        swal('Harap pilih berkas yang akan diimpor', '', 'error')
        return
      }

      const formData = new FormData()
      formData.append('excel', this.file)
      Promise.resolve(orderFactory.importOrder(formData))
        .then((response) => {
          if (response.data.rejected_orders) {
            this.import_result.rejected_orders = response.data.rejected_orders
          }
          if (response.data.saved_orders) {
            this.import_result.saved_orders = response.data.saved_orders
          }
          // empty file
          this.file = ''
          this.$refs.file.value = ''
        }).catch((e) => {
          swal('Gagal melakukan request', '', 'error')
          console.log(e)
          this.file = ''
          this.$refs.file.value = ''
        })
    },
    editPayment: function (order_id: any) {
      this.detailReady = false
      this.disableFileUpload = false
      Promise.all([
        orderFactory.detailOrder(order_id)
      ]).then(results => {
        this.order = results[0].data.order
        this.student = results[0].data.student
        this.billUserInstallments = results[0].data.bill_user_installments
        this.detailReady = true

        // set order.total_payment as default paid value
        this.param.total_payment = this.order.total_payment
        this.param.payment_date = this.order.payment_date || null

        if (this.order.reference) {
          this.param.reff_no = this.order.reference.reff_no || null
          if (this.order.reference.file_path) {
            this.disableFileUpload = true
          }
        }

        this.showPaymentModal()
      }).catch((e) => {
        swal('Gagal melakukan request', '', 'error')
        console.log(e)
      })
    },
    savePayment: function () {
      if (this.param.payment_date == null || this.param.payment_date == '') {
        swal('Harap isi Tanggal Pembayaran', '', 'error')
        return
      } else if (this.param.total_payment == null || isNaN(this.param.total_payment) || this.param.total_payment <= 0) {
        swal('Harap isi Nominal Pembayaran', '', 'error')
        return
      } else if (this.param.reff_no == null || this.param.reff_no == '') {
        swal('Harap isi Nomor Referensi', '', 'error')
        return
      } else if ((this.paymentFile == null || this.paymentFile == '') && this.disableFileUpload == false && !this.isUploadReferenceOptional) {
        swal('Harap pilih berkas yang akan diupload', '', 'error')
        return
      }

      this.loadingSave = true
      const formData = new FormData()

      formData.append('id', this.order.id)
      formData.append('payment_date', this.formatDate(this.param.payment_date))
      formData.append('total_payment', this.param.total_payment)
      formData.append('reff_no', this.param.reff_no)
      formData.append('file', this.paymentFile)

      Promise.resolve(orderFactory.savePayment(formData))
        .then((response) => {
          if (response.error == false) {
            swal('Sukses menyimpan pembayaran', '', 'success')
            this.hidePaymentModal()
            this.loadData()
            this.loadingSave = false
          } else {
            let messages = response.messages || []

            if (messages.length) {
              messages = messages.join('<br>')
            } else {
              messages = 'Gagal melakukan request'
            }

            swal(messages, '', 'error')
            this.loadingSave = false
          }
        }).catch((e) => {
          swal('Gagal melakukan request', '', 'error')
          console.log(e)
          this.loadingSave = false
        })
    },
    loadData: function (type: any) {
      if (type === 'refresh') {
        this.onPageChanged(1)
      }

      if (!this.param.child_user_id) {
        const child_user_id = this.$route.query.child_user_id
        this.param.child_user_id = child_user_id
      }
      /* if (this.searchField.length == 0) {
        this.param.child_user_id = ''
      } */

      const param = {
        status: this.param.status,
        date_from: '',
        date_to: '',
        keyword: this.param.keyword,
        offset: this.param.offset,
        limit: this.param.limit,
        order_by: 'desc',
        order_at: 'created_at',
        child_user_id: this.param.child_user_id,
        class_id: this.param.class_id,
        merchant_type: this.param.merchant_type
      }
      if (this.param.date_from) {
        param.date_from = this.formatDate(this.param.date_from)
      }
      if (this.param.date_to) {
        param.date_to = this.formatDate(this.param.date_to)
      }
      this.totalPaid = 0
      Promise.all([
        orderFactory.orders(param)
      ]).then(results => {
        this.orders = results[0].data.orders
        this.totalBill = results[0].data.total_rows
        this.totalPaid = results[0].data.total_paid?.total_paid
        this.custom_invoice = results[0].data.custom_invoice
        const limit = parseInt(this.param.limit)
        let totalPage = Math.round((this.totalBill + limit - 1) / limit)
        if ((totalPage * limit - this.totalBill) >= limit) {
          totalPage = Math.round(this.totalBill / limit)
        }
        this.totalPage = totalPage

        if (!this.searchField && this.param.child_user_id) {
          if (results[0].data.child) {
            this.searchField = results[0].data.child.name
          }
        }
        this.instance = String(localStorage.getItem('instance'))
      }).catch((e) => {
        swal('Gagal melakukan request', '', 'error')
        console.log(e)
      })
    },
    loadDataMaster: function () {
      Promise.all([
        masterDataFactory.master_datas(this.data_master)
      ]).then(results => {
        this.schoolYears = results[0].data.school_years
        this.months = results[0].data.months
        this.classes = results[0].data.classes
        this.merchants = results[0].data.merchants
        this.schoolYears.forEach((school_year: any) => {
          if (school_year.status == 'Active') {
            this.param.school_year_id = school_year.school_year_id
            this.school_year_name = school_year.name
          }
        })
        this.loadData()
        this.getBill()
      }).catch((e) => {
        swal('Gagal melakukan request', '', 'error')
        console.log(e)
      })
    },
    showModal: function () {
      this.myModal.show()
    },
    hideModal: function () {
      this.myModal.hide()
    },
    showPaymentModal: function () {
      this.paymentModal.show()
    },
    hidePaymentModal: function () {
      this.paymentModal.hide()
    },
    getBill: function () {
      const param = {
        school_year_id: this.param.school_year_id
      }
      Promise.resolve(billFactory.bill(param))
        .then(result => {
          this.billOption = result.data.bills
        })
        .catch((e) => {
          console.log(e)
        })
    },
    downloadTemplate: function () {
      Promise.resolve(billFactory.downloadManualPaymentFileTemplate())
        .then(() => {

        }).catch((e) => {
          swal('Gagal melakukan request', '', 'error')
          console.log(e)
        })
    },
    handlePaymentFileUpload: function () {
      this.payment_file = this.$refs.payment_file.files[0]
    },
    importPaymentFile: function () {
      if (this.payment_file == '' && this.$refs.payment_file.value != null) {
        swal('Harap pilih berkas yang akan diimpor', '', 'error')
        return
      }
      if (!this.spp_bill_id2) {
        swal('Harap pilih tagihan yang akan digunakan', '', 'error')
        return
      }

      const formData = new FormData()
      formData.append('excel', this.payment_file)
      formData.append('spp_bill_id', this.spp_bill_id2)

      Promise.resolve(billFactory.importManualPaymentFile(formData))
        .then((response) => {
          // check if is set errmessage
          if (response.data.errmessage) {
            swal({
              title: 'Error',
              icon: 'error',
              // className: 'swal-large',
              closeOnClickOutside: false,
              content: {
                element: 'div',
                attributes: {
                  innerHTML: '<ul style="text-align: left">' + response.data.errmessage.map((err: any) => `<li>${err}</li>`).join('') + '</ul>',
                  style: 'text-align: left'
                }
              }
              // button: "OK",
            })
            this.payment_file = ''
            this.spp_bill_id2 = ''
            this.$refs.payment_file.value = ''
            return
          }
          let failmessages = '<ul style="text-align: left">'
          let successmessages = '<ul style="text-align: left">'
          // var successCount = 0
          // var failCount = 0
          // looping response.data.successes
          for (var i = 0; i < response.data.successes.length; i++) {
            successmessages += `<li>${response.data.successes[i]}</li>`
            // successCount++
          }

          // looping response.data.errors
          for (var i = 0; i < response.data.errors.length; i++) {
            failmessages += `<li>${response.data.errors[i]}</li>`
            // failCount++
          }

          failmessages += '</ul>'
          successmessages += '</ul>'
          // var total = successCount + failCount
          const messages = `
            <h3>Result</h3>
            <p>Keterangan Berhasil</p>
            <div style="max-height: 200px; overflow-y: auto; border: 1px solid #ccc; padding: 5px;">
              ${successmessages}
            </div><br>
            <p>Keterangan Gagal</p>
            <div style="max-height: 200px; overflow-y: auto; border: 1px solid #ccc; padding: 5px;">
              ${failmessages}
            </div>
          `

          // swal(`Berhasil membuat ${response.data.order.length} order`, "", "success")
          swal({
            title: 'Import Pelunasan Manual',
            icon: 'success',
            className: 'swal-large',
            closeOnClickOutside: false,
            content: {
              element: 'div',
              attributes: {
                innerHTML: messages + '</ul>',
                style: 'text-align: left'
              }
            }
            // button: "OK",
          })
          this.payment_file = ''
          this.spp_bill_id2 = ''
          this.$refs.payment_file.value = ''
          // close modal
          this.pelunasanmanual.hide()
        }).catch((e) => {
          this.payment_file = ''
          this.spp_bill_id2 = ''
          this.$refs.payment_file.value = ''
          // close modal
          this.pelunasanmanual.hide()
          swal('Gagal melakukan request', '', 'error')
          console.log(e)
        }
        )
    },
    expireInvoice: function () {
      swal({
        title: 'Apakah Anda yakin?',
        text: 'Invoice ' + this.order.invoice_no + ' akan expire. Lakukan checkout untuk membuat invoice baru',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((willExpire) => {
        if (willExpire) {
          this.hidePaymentModal()
          Promise.resolve(orderFactory.expireInvoice({
            id: this.order.id
          }))
            .then((data) => {
              if (data.error == false) {
                swal('Invoice berhasil kedaluwarsa', '', 'success')
                this.loadData()
              } else {
                swal('Gagal melakukan request', '', 'error')
              }
            }).catch((e) => {
              swal('Gagal melakukan request', '', 'error')
              console.log(e)
            })
        }
      })
    },
    deleteInvoice: function () {
      swal({
        title: 'Apakah Anda yakin?',
        text: 'Invoice ' + this.order.invoice_no + ' akan dihapus',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          this.hidePaymentModal()
          Promise.resolve(orderFactory.deleteInvoice({
            id: this.order.id
          }))
            .then((data) => {
              if (data.error == false) {
                swal('Invoice berhasil dihapus', '', 'success')
                this.loadData()
              } else {
                swal('Gagal melakukan request', '', 'error')
              }
            }).catch((e) => {
              swal('Gagal melakukan request', '', 'error')
              console.log(e)
            })
        }
      })
    },
    downloadInvoice: function (order_id, invoice_no) {
      Promise.all([
        customerFactory.getCustomInvoice(order_id)
      ]).then(results => {
        if (results[0].error == false) {
          const inv = results[0].data
          this.downloadPDF(inv.data_url_file, invoice_no)
        } else {
          swal('Gagal melakukan request', '', 'error')
        }
      }).catch((e) => {
        swal('Gagal melakukan request', '', 'error')
        console.log(e)
      })
    },
    downloadPDF: function (pdf, invoice_no) {
      const linkSource = pdf
      const downloadLink = document.createElement('a')
      downloadLink.href = linkSource
      downloadLink.download = `invoice_#${invoice_no}.pdf`
      downloadLink.click()
    },
    selectAllOrders: function () {
      if (this.selectAll) {
        this.selected = this.orders.filter((order: any) => order.status == constants.ORDER_EXPIRED).map((order: any) => order.id)
      } else {
        this.selected = []
      }
      if (this.selected.length == 0) {
        setTimeout(() => {
          this.selectAll = false
        }, 100)
      }
    },
    deleteSelectedInvoice: function () {
      swal({
        title: 'Apakah Anda yakin?',
        text: 'Invoice yang dipilih akan dihapus',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          Promise.resolve(orderFactory.deleteSelectedInvoice({
            ids: this.selected
          }))
            .then((data) => {
              if (data.error == false) {
                swal('Invoice berhasil dihapus', '', 'success')
                this.loadData()
              } else {
                swal('Gagal melakukan request', '', 'error')
              }
            }).catch((e) => {
              swal('Gagal melakukan request', '', 'error')
              console.log(e)
            })
          this.selected = []
          this.selectAll = false
        }
      })
    },
    openReference: function (order: any) {
      this.reference.reff_no = order.reference?.reff_no || ''
      this.reference.invoice_no = order.invoice_no || ''
      this.reference.total_payment = order.total_payment || 0
      this.reference.payment_date = order.payment_date ? this.formatDate(order.payment_date) : ''
      this.reference.file_path = order.reference?.file_path || ''

      // Show the modal
      if (this.referenceModal) {
        this.referenceModal.show()
      }
    },
    getMerchantName: function (order: any) {
      let merchant_type = ''
      switch (order.merchant_type) {
        case 'bcah2h':
        case 'bca-offline':
          merchant_type = 'BCA'
          break
        case 'midtrans':
          merchant_type = 'Midtrans'
          break
        case 'ocbc':
          merchant_type = 'OCBC'
          break
        case 'panin-offline':
          merchant_type = 'Panin'
          break
        case 'xendit':
          if (order.custom_field3) {
            merchant_type = 'Xendit (' + (order.custom_field3 ?? '-') + ')'
          } else {
            merchant_type = 'Xendit'
          }
          break
        case 'cimb':
          merchant_type = 'CIMB'
          break
        case 'permata':
          merchant_type = 'Permata'
          break
        default:
          merchant_type = order.merchant_type ?? ''
          break
      }
      return merchant_type
    },
    openRefundModal: function (order_id: any) {
      this.refundForm = {
        date: new Date(),
        amount: 0,
        method: 'transfer',
        notes: '',
        max_refundable: 0
      }
      this.refundHistory = []
      this.refundFile = ''

      Promise.all([
        orderFactory.detailOrder(order_id),
        orderFactory.refundHistory(order_id)
      ]).then(results => {
        this.order = results[0].data.order
        this.student = results[0].data.student

        // Calculate max refundable
        const totalPaid = this.order.total_payment
        let totalRefunded = 0

        if (results[1].data && results[1].data.refunds) {
          this.refundHistory = results[1].data.refunds
          this.refundHistory.forEach((refund: any) => {
            totalRefunded += parseFloat(refund.amount)
          })
        }

        this.refundForm.max_refundable = totalPaid - totalRefunded
        this.refundForm.amount = this.refundForm.max_refundable // Default to max

        this.refundModal.show()
      }).catch((e) => {
        swal('Gagal melakukan request', '', 'error')
        console.log(e)
      })
    },

    handleRefundFileUpload: function (target: any) {
      this.refundFile = target.files[0]
    },

    submitRefund: function () {
      if (!this.refundForm.date) {
        swal('Harap isi Tanggal Refund', '', 'error')
        return
      }
      if (this.refundForm.amount <= 0) {
        swal('Nominal Refund harus lebih dari 0', '', 'error')
        return
      }
      if (this.refundForm.amount > this.refundForm.max_refundable) {
        swal('Nominal Refund tidak boleh melebihi sisa refundable', '', 'error')
        return
      }
      if (!this.refundFile) {
        swal('Harap upload Bukti Refund', '', 'error')
        return
      }

      this.loadingSave = true
      const formData = new FormData()
      formData.append('payment_date', this.formatDate(this.refundForm.date))
      formData.append('amount', this.refundForm.amount)
      formData.append('method', this.refundForm.method)
      formData.append('notes', this.refundForm.notes)
      formData.append('proof_file', this.refundFile)

      Promise.resolve(orderFactory.refund(this.order.id, formData))
        .then((response) => {
          this.loadingSave = false
          if (response.error == false) {
            swal('Refund berhasil disimpan', '', 'success')
            this.refundModal.hide()
            this.loadData()
          } else {
            let messages = response.messages || []

            if (messages.length) {
              messages = messages.join('<br>')
            } else {
              messages = 'Gagal menyimpan refund'
            }

            swal(messages, '', 'error')
          }
        }).catch((e) => {
          this.loadingSave = false
          swal('Terjadi kesalahan sistem', '', 'error')
          console.log(e)
        })
    }
  },
  async created() {
    Promise.resolve(setupFactory.getFeatureConfigs({ feature_configs: ['spp_disable_bill_checkboxes', 'spp_manual_payment_by_va', 'spp_enable_refund', 'spp_reference_upload_optional'] })).then(
      (res) => {
        if ('spp_disable_bill_checkboxes' in res.data.feature_configs && res.data.feature_configs.spp_disable_bill_checkboxes == 'true') {
          this.orderStatuses = {
            0: 'Semua Status',
            310: 'Aktif',
            320: 'Belum Bayar',
            330: 'Terbayar',
            340: 'Dibatalkan'
          }
        }
        if ('spp_manual_payment_by_va' in res.data.feature_configs && res.data.feature_configs.spp_manual_payment_by_va == 'true') {
          this.manualPaymentByVA = true
        }
        if ('spp_enable_refund' in res.data.feature_configs && res.data.feature_configs.spp_enable_refund == 'true') {
          this.enableRefund = true
        }
        if ('spp_reference_upload_optional' in res.data.feature_configs && res.data.feature_configs.spp_reference_upload_optional == 'true') {
          this.isUploadReferenceOptional = true
        }
      }
    )
  },
  async mounted() {
    // Check read access to /payment
    if (!roleAccessManager.canRead('/payment')) {
      swal('Error', 'Anda tidak memiliki akses ke halaman ini', 'error')
        .then(() => {
          this.$router.push('/loginpage')
        })
      return
    }

    // Set permission flags
    this.canCreate = roleAccessManager.canCreate('/payment')
    this.canRead = roleAccessManager.canRead('/payment')
    this.canUpdate = roleAccessManager.canUpdate('/payment')
    this.canDelete = roleAccessManager.canDelete('/payment')

    await this.loadDataMaster()

    const myModal = document.getElementById('orderModal')
    if (myModal != null) {
      this.myModal = new bootstrap.Modal(myModal)
    }

    const importModal = document.getElementById('importModal')
    if (importModal != null) {
      this.importModal = new bootstrap.Modal(importModal)
    }

    const paymentModal = document.getElementById('paymentModal')
    if (paymentModal != null) {
      this.paymentModal = new bootstrap.Modal(paymentModal)
    }

    const pelunasanmanual = document.getElementById('pelunasanmanual')
    if (pelunasanmanual != null) {
      this.pelunasanmanual = new bootstrap.Modal(pelunasanmanual)
    }

    const referenceModal = document.getElementById('referenceModal')
    if (referenceModal != null) {
      this.referenceModal = new bootstrap.Modal(referenceModal)
    }

    const refundModal = document.getElementById('refundModal')
    if (refundModal != null) {
      this.refundModal = new bootstrap.Modal(refundModal)
    }
  }
})

export default class Payment extends Vue { }
